import type { AuthState, Me } from '@regia/shared';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { http } from './api';
import { keys } from './query';

export function useAuthState() {
  return useQuery({
    queryKey: keys.auth,
    queryFn: () => http.get<AuthState>('/api/auth/state'),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}

export function useMe(): Me | null {
  return useAuthState().data?.user ?? null;
}

export function useLogout() {
  const qc = useQueryClient();
  return useCallback(async () => {
    try {
      await http.post('/api/auth/logout');
    } finally {
      qc.clear();
      window.location.assign('/accedi');
    }
  }, [qc]);
}
